import React, { useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTrash,
  faTimes,
  faCheck,
  faPaperclip,
  faPaperPlane,
} from "@fortawesome/free-solid-svg-icons";
import './AttachmentManagerModal.scss';

const AttachmentManagerModal = ({
  files,
  onRemove,
  onClose,
  onAddFiles,
  onSendMessage
}) => {
  const fileInputRef = useRef();
  const [message, setMessage] = useState("");

  const handleFileSelect = (event) => {
    const selected = Array.from(event.target.files);

    const validFiles = selected.filter(
      (file) =>
        file.type === "application/pdf" ||
        file.type === "image/jpeg" ||
        file.type === "image/png"
    );

    const invalid = selected.filter(
      (file) =>
        !["application/pdf", "image/jpeg", "image/png"].includes(file.type)
    );

    if (invalid.length > 0) {
      alert("Only PDF, JPG, PNG files are allowed.");
    }

    if (validFiles.length > 0) {
      onAddFiles(validFiles);
    }
  };

  const handleSend = () => {
    if (!message.trim()) return;
    onSendMessage(message.trim());
    setMessage("");
  };

  return (
    <div className="modal-attachment">
      <div className="modal-content-attachment">
        <div className="modal-header-attachment">
          <p style={{ fontSize: "18px" }}>Compose Message</p>
          <button className="close-button-attachment" onClick={onClose}>
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>

        <textarea
          rows="3"
          placeholder="Type your message here..."
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          style={{
            width: "100%",
            padding: "10px",
            borderRadius: "5px",
            border: "1px solid #ccc",
            marginBottom: "10px",
          }}
        />

        <button
          onClick={() => fileInputRef.current.click()}
          className="attach-file-button"
        >
          <FontAwesomeIcon icon={faPaperclip} /> Add Files
        </button>

        <input
          type="file"
          ref={fileInputRef}
          multiple
          onChange={handleFileSelect}
          style={{ display: "none" }}
        />

        <div style={{ maxHeight: "200px", overflowY: "auto", marginTop: "10px" }}>
        <div className="attachments-grid">
            {files.map((file, index) => {
              const isImage = file.type.startsWith("image/");
              const isPDF = file.type === "application/pdf";
              const previewUrl = isImage ? URL.createObjectURL(file) : null;

              return (
                <div className="attachment-box" key={index}>
                  <button
                    className="remove-btn"
                    onClick={() => onRemove(index)}
                    title="Remove"
                  >
                    <FontAwesomeIcon icon={faTimes} />
                  </button>

                  {isImage ? (
                    <img
                      src={previewUrl}
                      alt={file.name}
                      className="preview-thumbnail"
                    />
                  ) : (
                    <div className="file-icon-box">
                      <span role="img" aria-label="pdf" className="pdf-icon">📄</span>
                      <small className="file-name">{file.name}</small>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>

        <div style={{ display: "flex", justifyContent: "space-between", marginTop: "15px" }}>
          <button
            onClick={handleSend}
            className="confirm-button"
            disabled={!message.trim() || files.length ==0}
          >
            <FontAwesomeIcon icon={faPaperPlane} /> Send
          </button>
          <button onClick={onClose} className="cancel-button">
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default AttachmentManagerModal;